/* ================================================================
   MATRIX FOREX — THEME JS  v3.0
   Consumes the global rate utility (window.MatrixRates) for ALL
   currency rendering on the site. No duplicate API logic.
   ================================================================ */
(function () {
  'use strict';

  var R = window.MatrixRates;

  function precision(rate) {
    if (!rate && rate !== 0) return 2;
    return rate < 0.01 ? 6 : rate < 0.1 ? 5 : rate < 10 ? 3 : 2;
  }

  /* ── TICKER ─────────────────────────────────────────────────── */
  function buildTicker() {
    var track = document.getElementById('ticker-track') || document.querySelector('.ticker-track');
    if (!track || !R) return;
    var rates = R.getAll(); var codes = Object.keys(rates);
    if (!codes.length) return;
    var items = '';
    for (var pass = 0; pass < 2; pass++) {
      codes.forEach(function (code) {
        var rate = rates[code] && rates[code].buy;
        if (!rate) return;
        var flag = R.flag(code);
        items += '<div class="t-item">' + flag + ' ' + code + ' <span class="t-val">₹' + rate.toFixed(precision(rate)) + '</span></div>';
      });
    }
    track.innerHTML = items;
  }

  /* ── CURRENCY MARQUEE (homepage) ─────────────────────────────── */
  function buildMarquee() {
    if (!R) return;
    var rates = R.getAll(); var codes = Object.keys(rates);
    if (!codes.length) return;
    ['cur-track-1','cur-track-2'].forEach(function (id, idx) {
      var track = document.getElementById(id) || document.querySelectorAll('.cur-track')[idx];
      if (!track) return;
      var pills = '';
      for (var pass = 0; pass < 2; pass++) {
        codes.forEach(function (code) {
          var rate = rates[code] && rates[code].buy;
          if (!rate) return;
          var flag = R.flag(code);
          pills += '<div class="cur-pill"><span class="cf">' + flag + '</span>' + code + '<span class="cr">₹' + rate.toFixed(precision(rate)) + '</span></div>';
        });
      }
      track.innerHTML = pills;
    });
  }

  /* ── HERO FORM CALCULATOR (legacy markup) ────────────────────── */
  function initHeroCalc() {
    var sel   = document.getElementById('calc-currency');
    var amt   = document.getElementById('calc-amount');
    var res   = document.getElementById('calc-result');
    var rDisp = document.getElementById('calc-rate-display');
    var save  = document.getElementById('calc-save');
    if (!sel || !amt || !res || !R) return;

    Array.from(sel.options).forEach(function (opt) {
      var code = opt.dataset.code;
      var rec  = code && R.get(code);
      if (rec) {
        opt.value = rec.buy;
        opt.dataset.markup = (rec.buy * 1.07).toFixed(4);
      }
    });

    function calc() {
      var a = parseFloat(amt.value) || 0;
      var r = parseFloat(sel.value) || 0;
      var mk = parseFloat(sel.options[sel.selectedIndex].dataset.markup || r * 1.07);
      var total = a * r;
      var saving = (a * mk) - total;
      var code = sel.options[sel.selectedIndex].dataset.code || '';
      res.textContent = '₹' + total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (rDisp) rDisp.textContent = '1 ' + code + ' = ₹' + r.toLocaleString('en-IN');
      if (save && saving > 0) save.textContent = 'You save ~₹' + Math.round(saving).toLocaleString('en-IN') + ' vs airport';
    }
    amt.addEventListener('input', calc);
    sel.addEventListener('change', calc);
    calc();
  }

  /* ── BRANCH RATE CALCULATOR ──────────────────────────────────── */
  function initBranchCalc() {
    var inrEl  = document.getElementById('branch-inr');
    var curEl  = document.getElementById('branch-cur');
    var outEl  = document.getElementById('branch-out');
    var rateEl = document.getElementById('branch-rate');
    var saveEl = document.getElementById('branch-save');
    if (!inrEl || !curEl || !outEl || !R) return;

    Array.from(curEl.options).forEach(function (opt) {
      var rec = opt.dataset.code && R.get(opt.dataset.code);
      if (rec) opt.value = rec.buy;
    });

    function brCalc() {
      var inr  = parseFloat(inrEl.value) || 0;
      var rate = parseFloat(curEl.value) || 1;
      var code = curEl.options[curEl.selectedIndex].dataset.code || '';
      var out  = inr / rate;
      var airportRate = rate * 0.93;
      var saving = (inr / airportRate) - out;
      outEl.textContent = out.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' ' + code;
      if (rateEl) rateEl.textContent = '1 ' + code + ' = ₹' + rate.toLocaleString('en-IN') + ' · Fee: ₹0';
      if (saveEl) saveEl.textContent = 'Airport charges ~7% more · You save ~' + saving.toFixed(2) + ' ' + code;
    }
    inrEl.addEventListener('input', brCalc);
    curEl.addEventListener('change', brCalc);
    brCalc();
  }

  /* ── STICKY NAV ──────────────────────────────────────────────── */
  var nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ── MOBILE MENU + COLLAPSIBLE SUBMENUS ──────────────────────── */
  var burger  = document.getElementById('nav-burger');
  var mobMenu = document.getElementById('mob-menu');
  if (burger && mobMenu) {
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = mobMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
      burger.classList.toggle('is-open', open);
      document.body.classList.toggle('mob-menu-open', open);
    });
    document.addEventListener('click', function (e) {
      if (nav && !nav.contains(e.target) && !mobMenu.contains(e.target)) {
        mobMenu.classList.remove('open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mob-menu-open');
      }
    });
    /* Click-to-expand submenus (no auto-open) */
    mobMenu.querySelectorAll('.mob-sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.mob-item');
        if (!item) return;
        var willOpen = !item.classList.contains('open');
        mobMenu.querySelectorAll('.mob-item.open').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
        item.classList.toggle('open', willOpen);
      });
    });
  }

  /* ── FAQ ACCORDION ───────────────────────────────────────────── */
  // document.querySelectorAll('.faq-item').forEach(function (item) {
  //   item.addEventListener('click', function () {
  //     var wasOpen = item.classList.contains('open');
  //     document.querySelectorAll('.faq-item.open').forEach(function (o) {
  //       o.classList.remove('open');
  //       var p = o.querySelector('.faq-plus'); if (p) p.textContent = '+';
  //     });
  //     if (!wasOpen) {
  //       item.classList.add('open');
  //       var p = item.querySelector('.faq-plus'); if (p) p.textContent = '×';
  //     }
  //   });
  // });


//   document.querySelectorAll('#chFaqs .faq-q-line').forEach(function(question){

//   question.addEventListener('click', function(){

//     const currentRow = this.closest('.faq-row');
//     const wasOpen = currentRow.classList.contains('active');

//     document.querySelectorAll('#chFaqs .faq-row').forEach(function(row){
//       row.classList.remove('active');
//     });

//     if (!wasOpen) {
//       currentRow.classList.add('active');
//     }

//   });

// });

document.querySelectorAll('details.faq-row').forEach(function(detail){

  detail.addEventListener('toggle', function(){

    if (!detail.open) return;

    document.querySelectorAll('details.faq-row').forEach(function(other){

      if (other !== detail){
        other.open = false;
      }

    });

  });

});

  /* ── HERO FORM TABS (legacy support) ─────────────────────────── */
  document.querySelectorAll('.hf-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var parent = tab.closest('.hf-tabs');
      if (!parent) return;
      parent.querySelectorAll('.hf-tab').forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var svc = tab.closest('form') && tab.closest('form').querySelector('.hf-service-input');
      if (svc) svc.value = tab.textContent.trim();
    });
  });

  /* ── SCROLL REVEAL ───────────────────────────────────────────── */
  var revealEls = document.querySelectorAll('[data-animate], .reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view', 'visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  /* ── REVIEWS CAROUSEL CONTROLS ───────────────────────────────── */
  document.querySelectorAll('[data-rev-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-rev-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    function step(dir) {
      var card = track.querySelector('.mx-review-card');
      var w = card ? card.offsetWidth + 18 : 320;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  /* ── CITIES TABS ─────────────────────────────────────────────── */
  document.querySelectorAll('.cfs-tab-nav').forEach(function (nav) {
    nav.querySelectorAll('.cfs-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var city = tab.getAttribute('data-city');
        if (!city) return;
        var section = nav.closest('.cfs-section') || document;
        section.querySelectorAll('.cfs-tab').forEach(function (t) {
          var a = t.getAttribute('data-city') === city;
          t.classList.toggle('cfs-tab--active', a);
          t.setAttribute('aria-selected', a ? 'true' : 'false');
        });
        section.querySelectorAll('.cfs-panel').forEach(function (p) {
          var match = p.id === 'cfs-panel-' + city;
          p.classList.toggle('cfs-panel--active', match);
          if (!match) p.setAttribute('hidden', ''); else p.removeAttribute('hidden');
        });
      });
    });
  });

  /* ── BLOG TAG FILTER ─────────────────────────────────────────── */
  var blogRoot = document.querySelector('[data-blog-root]');
  if (blogRoot) {
    var pills = blogRoot.querySelectorAll('[data-blog-pill]');
    var cards = blogRoot.querySelectorAll('[data-blog-card]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tag = pill.getAttribute('data-blog-pill');
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        cards.forEach(function (card) {
          if (tag === 'all') { card.style.display = ''; return; }
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          card.style.display = tags.indexOf(tag.toLowerCase()) > -1 ? '' : 'none';
        });
      });
    });
  }

  /* ── SMOOTH ANCHOR SCROLL ────────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ── WHATSAPP FLOAT PULSE ────────────────────────────────────── */
  var wa = document.querySelector('.wa-bubble');
  if (wa) {
    setTimeout(function () { wa.style.animation = 'waPulse 2s ease-in-out 3'; }, 4000);
  }

  /* ── BOOT: re-render rate UI when global rates arrive ────────── */
  function refreshRateWidgets() { buildTicker(); buildMarquee(); initHeroCalc(); initBranchCalc(); }
  if (R) R.onReady(refreshRateWidgets);
  document.addEventListener('matrix-rates-ready', refreshRateWidgets);

})();

/* ================================================================
   v4 ADDITIONS — Nav search (currency + country picker), FAQ, Wise tabs
   ================================================================ */
(function () {
  'use strict';

  /* ── Nav search ────────────────────────────────────────────── */
  var btn   = document.getElementById('nav-search-toggle');
  var panel = document.getElementById('nav-search-panel');
  var input = document.getElementById('nav-search-input');
  var out   = document.getElementById('nav-search-results');
  if (btn && panel && input && out) {
    var INDEX = [
      // currency code + country/use cases. Each row: [label, sub, href, search]
        ['USD', 'United States — INR to USD', '/pages/inr-to-usd', 'usd dollar america united states us'],
      ['EUR', 'Euro Zone — INR to EUR', '/pages/inr-to-eur', 'eur euro europe'],
      ['GBP', 'United Kingdom — INR to GBP', '/pages/inr-to-gbp', 'gbp pound uk britain england london'],
      ['AED', 'UAE — INR to AED', '/pages/inr-to-aed', 'aed dirham uae dubai abu dhabi'],
      ['AUD', 'Australia — INR to AUD', '/pages/inr-to-aud', 'aud australian dollar australia sydney melbourne'],
      ['CAD', 'Canada — INR to CAD', '/pages/inr-to-cad', 'cad canadian dollar canada toronto vancouver'],
      ['SGD', 'Singapore — INR to SGD', '/pages/inr-to-sgd', 'sgd singapore dollar'],
      ['THB', 'Thailand — INR to THB', '/pages/inr-to-thb', 'thb thai baht thailand bangkok phuket'],
      ['JPY', 'Japan — INR to JPY', '/pages/inr-to-jpy', 'jpy yen japan tokyo'],
      ['CHF', 'Switzerland — INR to CHF', '/pages/inr-to-chf', 'chf swiss franc switzerland'],
      ['NZD', 'New Zealand — INR to NZD', '/pages/inr-to-nzd', 'nzd new zealand dollar'],
      ['SAR', 'Saudi Arabia — INR to SAR', '/pages/inr-to-sar', 'sar riyal saudi arabia mecca medina'],
      ['QAR', 'Qatar — INR to QAR', '/pages/inr-to-qar', 'qar riyal qatar doha'],
      ['MYR', 'Malaysia — INR to MYR', '/pages/inr-to-myr', 'myr ringgit malaysia kuala lumpur'],
      ['HKD', 'Hong Kong — INR to HKD', '/pages/inr-to-hkd', 'hkd hong kong dollar'],
      ['ZAR', 'South Africa — INR to ZAR', '/pages/inr-to-zar', 'zar rand south africa'],
      ['CNY', 'China — INR to CNY', '/pages/inr-to-cny', 'cny yuan china beijing shanghai'],
      ['IDR', 'Indonesia — INR to IDR', '/pages/inr-to-idr', 'idr rupiah indonesia bali jakarta'],
      ['VND', 'Vietnam — INR to VND', '/pages/inr-to-vnd', 'vnd dong vietnam hanoi'],
      ['KRW', 'South Korea — INR to KRW', '/pages/inr-to-krw', 'krw won south korea seoul'],
      ['DKK', 'Denmark — INR to DKK', '/pages/inr-to-dkk', 'dkk danish krone denmark copenhagen'],
      ['NOK', 'Norway — INR to NOK', '/pages/inr-to-nok', 'nok norwegian krone norway oslo'],
      ['SEK', 'Sweden — INR to SEK', '/pages/inr-to-sek', 'sek swedish krona sweden stockholm'],
      ['MUR', 'Mauritius — INR to MUR', '/pages/inr-to-mur', 'mur mauritius rupee'],
      ['LKR', 'Sri Lanka — INR to LKR', '/pages/inr-to-lkr', 'lkr sri lanka rupee colombo'],
      ['BDT', 'Bangladesh — INR to BDT', '/pages/inr-to-bdt', 'bdt taka bangladesh dhaka'],
      ['CZK', 'Czech Republic — INR to CZK', '/pages/inr-to-czk', 'czk koruna czech prague'],
      ['RUB', 'Russia — INR to RUB', '/pages/inr-to-rub', 'rub ruble russia moscow'],
      // service entry points
      ['Send Money',        'Transfer money abroad', '/pages/student-remittance', 'send money remittance transfer wire swift'],
      ['Forex Card',        'Multi-currency travel card', '/pages/forex-card', 'forex card multi currency travel card'],
      ['Branches',          'All Matrix Forex branches', '/pages/locations', 'branches locations cities'],
      ['Corporate Forex',   'For businesses', '/pages/corporate', 'corporate business b2b'],
      ['Sell Forex',        'Sell leftover currency', '/pages/sell-forex', 'sell forex usd cash buyback']
    ];

    function open() { panel.classList.add('open'); setTimeout(function(){ input.focus(); }, 60); }
    function close() { panel.classList.remove('open'); }
    function render(q) {
      q = (q || '').trim().toLowerCase();
      if (!q) {
        out.innerHTML = '<div class="nav-search-results-empty">Type a currency or country to begin (USD, Dubai, Thailand…)</div>';
        return;
      }
      var hits = INDEX.filter(function (row) { return row[3].indexOf(q) > -1 || row[0].toLowerCase().indexOf(q) > -1; }).slice(0, 12);
      if (!hits.length) {
        out.innerHTML = '<div class="nav-search-results-empty">No matches. Try USD, EUR, GBP, AED…</div>';
        return;
      }
      out.innerHTML = hits.map(function (h) {
        return '<a href="' + h[2] + '"><strong>' + h[0] + '</strong> — ' + h[1] + '</a>';
      }).join('');
    }
    btn.addEventListener('click', function (e) { e.stopPropagation(); panel.classList.contains('open') ? close() : open(); render(''); });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== btn && !btn.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); render(''); }
    });
    input.addEventListener('input', function (e) { render(e.target.value); });
    render('');

    /* ── Mobile search inside hamburger ── */
    var mInput = document.getElementById('mob-search-input');
    var mOut   = document.getElementById('mob-search-results');
    if (mInput && mOut) {
      function mRender(q) {
        q = (q || '').trim().toLowerCase();
        if (!q) { mOut.innerHTML = ''; return; }
        var hits = INDEX.filter(function (row) {
          return row[3].indexOf(q) > -1 || row[0].toLowerCase().indexOf(q) > -1;
        }).slice(0, 10);
        if (!hits.length) { mOut.innerHTML = '<div class="mob-search-empty">No matches. Try USD, EUR, GBP, AED…</div>'; return; }
        mOut.innerHTML = hits.map(function (h) {
          return '<a href="' + h[2] + '"><strong>' + h[0] + '</strong> — ' + h[1] + '</a>';
        }).join('');
      }
      mInput.addEventListener('input', function (e) { mRender(e.target.value); });
    }
  }

  /* ── Custom single-line FAQ (event-delegated for dynamic FAQs) ─ */
  // document.addEventListener('click', function (e) {
  //   var row = e.target.closest('.faq-stacked .faq-row');
  //   if (!row) return;
  //   row.classList.toggle('active');
  // });

    /* ── FAQ ACCORDION — single global controller (single-open) ────
     Drives every .faq-row variant in the theme:
       • <details class="faq-row">  (homepage FAQ, currency-pair-content)
       • <div class="faq-row">       (currency hub/rate/convert, send-money, country)
     Auto-close is scoped to the nearest .faq-stacked group, so two FAQ
     widgets on one page never close each other.
     The .faq-item pages (location-master, page-forex-services) keep
     their own self-contained scripts and are intentionally untouched. */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.faq-q-line');
    if (!head) return;

    var row = head.closest('.faq-row');
    if (!row) return;

    // Native <details>: suppress the browser's own toggle so the
    // .active class stays the single source of truth.
    if (row.tagName === 'DETAILS') e.preventDefault();

    var willOpen = !row.classList.contains('active');
    var group = row.closest('.faq-stacked') || row.parentElement;

    // Close every row in THIS group first
    group.querySelectorAll('.faq-row').forEach(function (o) {
      o.classList.remove('active');
      if (o.tagName === 'DETAILS') o.open = false;
    });

    // Then open the clicked one (clicking an open row closes it)
    if (willOpen) {
      row.classList.add('active');
      if (row.tagName === 'DETAILS') row.open = true;
    }
  });

  /* ── Wise-style tabs ──────────────────────────────────────── */
  document.querySelectorAll('.we-section').forEach(function (root) {
    var tabs = root.querySelectorAll('.we-tab');
    var panes = root.querySelectorAll('.we-pane');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
        panes.forEach(function (p) { p.classList.toggle('active', p.dataset.pane === target); });
      });
    });
  });
})();
